import React from 'react';
import './css/FooterStyle.css';
import { Link } from "react-router-dom";
import footerlogo from './images/vigyan-vriksh-footerlogo.png';
import vvplaystore from './images/vigyanvrikshplaystore.gif';
import appleappstore from './images/app-store.png';
import { HashLink } from "react-router-hash-link";

function Footer() {
    return (
        <div>
          <div className="container-fluid footerbox">
            <div className="main-box">
              <div className="row">
                <div className="col-md-5">  
                  <hr />
                  <h2 className="">Unlock Your Online Education With <span>VIGYAN VRIKSH</span></h2>
                </div>
                <div className="col-md-7 text-center">
                  <div className="row justify-content-center icon-fullbox">
                    <div className="col-12 col-md-3 fibox">
                      <div className="icon-box">
                        <i className="bi bi-people"></i>
                        <p className="fw-semibold mb-0">Community</p>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 fibox">
                      <div className="icon-box">
                        <i className="bi bi-link-45deg"></i>
                        <p className="fw-semibold mb-0">Referrals</p>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 fibox">
                      <div className="icon-box">
                        <i className="bi bi-journals"></i>
                        <p className="fw-semibold mb-0">Assignments</p>
                      </div>
                    </div>
                    <div className="col-12 col-md-3 fibox">
                      <div className="icon-box">
                        <i className="bi bi-patch-exclamation"></i>
                        <p className="fw-semibold mb-0">Certificates</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <footer className="footer">
            <div className="container-fluid footernav">
              <div className="row gy-4">
                <div className="col-md-3">
                  <img src={footerlogo} alt="Vigyan Vriksh Logo" style={{ width: "90%" }} />
                  <p className="mt-3">Empowering students with optimized exam strategies for success in government exams, IIT, CUET, CSIR, and PGT.</p>
                  <h4>FOLLOW US ON:</h4>
                  <div className="social-icons">
                    <div className="icon"><Link to="https://www.facebook.com/profile.php?id=61550105037929&mibextid=ZbWKwL" target='_blank'><i className="bi bi-facebook"></i></Link></div>
                    <div className="icon"><Link to="https://www.instagram.com/vigyanvriksh/" target='_blank'><i className="bi bi-instagram"></i></Link></div>
                    <div className="icon"><Link to="linkedin.com/company/vigyan-vriksh" target='_blank'><i className="bi bi-linkedin"></i></Link></div>
                    <div className="icon"><Link to="https://t.me/vigyanvrikshofficial" target='_blank'><i class="bi bi-telegram"></i></Link></div>
                  </div>
                </div>
                <div className="col-md-2">
                  <h5>Useful Links</h5>
                  <ul className="list-unstyled">
                    <li>
  <HashLink smooth to="/about#whyus">
    Why Vigyan Vriksh
  </HashLink>
</li>
                    <li><Link to="/About" className="nav-link">About Us</Link></li>
                    <li><Link to="/blog" className="nav-link">Blog</Link></li>
                    <li><Link to="/Contact" className="nav-link">Contact</Link></li>
                  </ul>
                </div>
                <div className="col-md-2">
                  <h5>Resources</h5>
                  <ul className="list-unstyled">
                    <li><Link to="https://www.youtube.com/playlist?list=PLZo9kcReuSw2MJxkkzoyOHowzhfCVM8k6" target='_blank'>Expert Videos</Link></li>
                    <li><Link to="">Request A Demo</Link></li>
                    <li><Link to="">Test Series</Link></li>
                    <li><Link to="">Previous year question papers</Link></li>
                  </ul>
                </div>
                <div className="col-md-2">
                  <h5>Careers </h5>
                  <ul className="list-unstyled">
                    <li><Link to="">................</Link></li>
                    <li><Link to="https://www.google.com/maps/dir//H,+1449,+Outram+Ln,+GTB+Nagar,+Delhi,+110009/@28.704283,77.1280926,27826m/data=!3m1!1e3!4m8!4m7!1m0!1m5!1m1!1s0x390cfdde3d2dee83:0x88atarget='_blank'bdb2639ea7060!2m2!1d77.210494!2d28.704308?entry=ttu&g_ep=EgoyMDI1MDkwNy4wIKXMDSoASAFQAw%3D%3D" target='_blank'>Sitemap</Link></li>
                    <li><Link to="">Testimonials</Link></li>
                    <li><Link to="https://vigyanvariksh.classx.co.in/" target='_blank'>Sign In / Register</Link></li>
                  </ul>
                </div>
                <div className="col-md-3 newsletter">
                  <h5>Get in touch!</h5>
                  <p className="d-block mt-2">Speak with our academic counselors today at 9717270400 for expert guidance on your exam preparation.</p>
                  <Link to="https://play.google.com/store/apps/details?id=com.vigyan.vriksha" target='_blank'><img src={vvplaystore} alt='' style={{width : "150px"}} /></Link>
                  <Link to="https://apps.apple.com/in/app/my-appx/id1662307591" target='_blank'><img src={appleappstore} alt=''  style={{width : "150px"}} /></Link>
                </div>
              </div>
            </div>
          </footer>

          <div className="footerbottom">
            <div className="container-fluid">
              <div className="row gy-4 text-white">
                <div className="col-md-6">
                  <p>© 2025 All right reserved by <span className='text-denger'>vigyan vriksh</span></p>
                </div>
                <div className="col-md-6">
                  <ul class="footerlink">
							      <li class=""><Link to='/Terms-condition'>Terms &amp; Conditions</Link></li>
    								<li class=""><Link to='/Privacy-policy'>Privacy policy</Link></li>
                    <li class=""><Link to='/Refund-policy'>Refund policy</Link></li>
						      </ul>
                </div>
              </div>
            </div>
          </div>

          <button type="button" id="backToTop" className="btn btn-danger btn-lg rounded-circle">
            <i className="fas fa-arrow-up"></i>
          </button>
        </div>
    );
}

export default Footer;
